// libraries
import Vue from 'vue'
import Router from 'vue-router'

// components
import mastersOfMarketing from '@/screens/masters-of-marketing/index.vue'
import crushYourQuota from '@/screens/crush-your-quota/index.vue'
import crushYourQuotaSpeakerApplication from '@/screens/crush-your-quota-speakers/index.vue'
import home from '@/screens/home/index.vue'
import aboutUs from '@/screens/aboutUs/index.vue'

import fast from '@/screens/fast/index.vue'
import fastGrowingCompany from '@/screens/fast-growing-company/index.vue'
import fastGrowingDepartmentLocation from '@/screens/fast-growing-department-location/index.vue'
import cleanCRM from '@/screens/crm/index.vue'
import funded from '@/screens/funding/index.vue'
import landExpand from '@/screens/land-and-expand/index.vue'
import newHires from '@/screens/track-new-hires/index.vue'

import introSet from '@/screens/thankyou/index.vue'
//import privacy from '@/screens/policies/index.vue'
import reportAbuse from '@/screens/policies/report-abuse.vue'
import termsOfUse from '@/screens/policies/terms-of-service.vue'
import messagingPolicy from '@/screens/policies/messaging-policy.vue'
import privacyPolicy from '@/screens/policies/privacy-policy.vue'
import craigZ from '@/screens/speakers/index.vue'
import nikkiE from '@/screens/resources/nikkiE.vue'
import taylorR from '@/screens/resources/taylorRyan.vue'
import zonteeH from '@/screens/resources/zonteeH.vue'
// import adamM from '@/screens/resources/adamM.vue'
// import shepH from '@/screens/resources/shepH.vue'


Vue.use(Router)

// routes
const routes = [
  {
    path: '/',
    component: home,
  },
  {
    path: '/masters-of-marketing',
    component: mastersOfMarketing,
  },
  {
    path: '/shows/crush-your-quota',
    component: crushYourQuota,
  },
  {
    path: '/shows/crush-your-quota/speaker-application',
    component: crushYourQuotaSpeakerApplication,
  },
  {
    path: '/about-us',
    component: aboutUs,
  },
  {
    path: '/privacy',
    component: privacyPolicy,
  },
  {
    path: '/recipes/track-fast-growing-companies',
    component: fastGrowingCompany,
  },
  {
    path: '/fast-growing-department-location',
    component: fastGrowingDepartmentLocation,
  },
  {
    path: '/recipes/clean-your-dirty-crm',
    component: cleanCRM,
  },
  {
    path: '/recipes/track-recently-funded-companies',
    component: funded,
  },
  {
    path: '/recipes/track-new-hires-across-your-tam',
    component: newHires,
  },
  {
    path: '/recipes/land-and-expand-accounts',
    component: landExpand,
  },


  {
    path: '/intro-set/:first_name',
    component: introSet,
  },

  /*{
    path: '/terms-of-use',
    component: aboutUs,
  },
  {
    path: '/messaging-policy',
    component: aboutUs,
  },
  */
  {
    path: '/report-abuse',
    component: reportAbuse,
  },
  {
    path: '/terms-of-use',
    component: termsOfUse,
  },
  {
    path: '/messaging-policy',
    component: messagingPolicy,
  },
  {
    path: '/contact-us',
    component: termsOfUse,
  },



  // SPEAKERS
  {
    path: '/speakers/craig-zingerline',
    component: craigZ,
  },
  {
    path: '/speakers/deirdre-breakenridge',
    component: craigZ,
  },







  // Past Presentations
  {
    path: '/resources/email/supercharge-your-email-sending-practices-with-copy-hacker-nikki-elbaz',
    component: nikkiE,
  },
  {
    path: '/resources/unconventional-marketing/marketing-with-bootstrapped-methodologies-in-quarantine-taylor-ryan',
    component: taylorR,
  },
  {
    path: '/resources/events/pivoting-to-virtual-events-zontee-hou',
    component: zonteeH,
  },
  {
    path: '/resources/email/supercharge-your-email-sending-practices-with-copy-hacker-nikki-elbaz',
    component: nikkiE,
  },
  
  // {
  //   path: '/resources/email/shep-hyken',
  //   component: shepH,
  // },
  // {
  //   path: '/resources/email/adam-morgan',
  //   component: adamM,
  // },

]

export default new Router({
  mode: 'history',
  routes,
})
